import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalWorkflowComponent, FLOW_TYPE } from '../../../../../@shared/components/approval-workflow/approval-workflow.component';
import { ButtonComponent } from '../../../../../@core/components/ui/button/button.component';
import { CONTRACT_APPROVAL_STATUS } from '../../../../../@shared/components/user-chips/user-chips.component';
import { CONTRACT_STATUS } from '../../../../../@shared/components/badge/badge.enums';
import { CONTRACT_USER_ROLE } from '../../../../../@core/models/model';
import { EditContractDataService } from '../../../../services/edit-contract-data.service';
import { AssetUrlPipe } from '../../../../../@shared/pipes/asset-url.pipe';
import { SocketService, SOCKET_EVENTS } from '../../../../../@core/services/socket.service';
import { Subscription } from 'rxjs';
import { IContractApprovalConf } from '../../../../models/contract-management.model';

@Component({
    selector: 'app-approvers-tab',
    standalone: true,
    imports: [CommonModule, ApprovalWorkflowComponent, ButtonComponent, AssetUrlPipe],
    template: `
        <div class="h-full w-full overflow-auto">
        <div *ngIf="approvalConf() && approvalConf()!.approvers.length === 0; else approversList"
            class="flex flex-col justify-center h-full">
            <div class="flex flex-col justify-center items-center gap-4 p-2" style="margin-top: 10%">
                <div class="approver-file">
                    <img [src]="'images/comments-initial-screen.svg' | assetUrl" alt="link" class="relative z-0">
                    <div class="vector-approver-left">
                        <img [src]="'images/orange-top.svg' | assetUrl" alt="">
                    </div>
                    <div class="vector-approver-right">
                        <img [src]="'images/blue-bottom.svg' | assetUrl" alt="">
                    </div>
                </div>
                <div class="approver-text">
                    <h2 class="font-semibold text-base text-center">No Approver Added Yet</h2>
                    <p class="info text-sm">Approver will be shown here once added by the admin</p>
                </div>
                <div class="flex flex-row justify-center gap-2 w-full relative z-20">
                    @if(currentRole() === CONTRACT_USER_ROLE.OWNER || currentRole() === CONTRACT_USER_ROLE.EDITOR){
                        <!-- disable if it is skipped -->
                    <app-button (clicked)="toggleApproveDialog()" variant="filled" severity="primary"
                        label="Add Approver" icon="pi pi-plus"
                        [disabled]="!(contract()?.status === CONTRACT_STATUS.READY_FOR_APPROVAL || contract()?.status === CONTRACT_STATUS.DRAFT) || approvalConf()?.status === CONTRACT_APPROVAL_STATUS.SKIPPED" />
                    <app-button (clicked)="skipApprovalFlow()" variant="outlined" severity="primary"
                        [disabled]="!(contract()?.status === CONTRACT_STATUS.READY_FOR_APPROVAL || contract()?.status === CONTRACT_STATUS.PENDING_APPROVAL || contract()?.status === CONTRACT_STATUS.DRAFT) || approvalConf()?.status === CONTRACT_APPROVAL_STATUS.SKIPPED || approvalConf()?.status === CONTRACT_APPROVAL_STATUS.APPROVED"
                        [label]="approvalConf()?.status === CONTRACT_APPROVAL_STATUS.SKIPPED ? 'Skipped' : 'Skip Approval'" />
                    }
                </div>
            </div>
        </div>

        <ng-template #approversList>
            <div class="flex flex-col p-2 h-full">
                <div class="flex flex-row justify-between">
                    <div class="flex items-center" id="step5">
                        <span class="text-lg font-semibold">Approvers</span>
                        <span
                            *ngIf="approvalConf() && (approvalConf()!.status === CONTRACT_APPROVAL_STATUS.SKIPPED)"
                            class="text-xs font-semibold text-green-500 ml-2 bg-green-100 rounded-md px-2 py-0.5">
                            Skipped
                        </span>
                    </div>
                    <div *ngIf="currentRole() === CONTRACT_USER_ROLE.OWNER || currentRole() === CONTRACT_USER_ROLE.EDITOR">
                        <app-button label="Reset" icon="pi pi-refresh" *ngIf="permissions()?.canEdit"
                            [disabled]="!(approvalConf() && (approvalConf()!.status === CONTRACT_APPROVAL_STATUS.WAITING))"
                            (clicked)="resetApprovalFlow()" variant="outlined" severity="contrast" />
                    </div>
                </div>
                <div class="flex-grow overflow-hidden mt-4">
                    <div class="h-full overflow-auto no-scrollbar">
                        <app-approval-workflow *ngIf="approvalConf() && approvalConf()!.approvers.length > 0"
                            [approvers]="allApprovers()" [canEdit]="!permissions()?.canEdit && !isOwner()"
                            (deleteApproverEvent)="approvalChange()" [flowType]="flowType.APPROVAL">
                        </app-approval-workflow>
                    </div>
                </div>
                <div *ngIf="isOwner() || isEditor()" class="flex flex-row justify-between p-2">
                    <app-button
                        [label]="(approvalConf()?.approvers?.length || 0) === 0 ? 'Add Approver' : 'Edit Approvers'"
                        [icon]="(approvalConf()?.approvers?.length || 0) === 0 ? 'pi pi-plus' : 'pi pi-pencil'"
                        [disabled]="!(contract()?.status === CONTRACT_STATUS.READY_FOR_APPROVAL || contract()?.status === CONTRACT_STATUS.DRAFT) || approvalConf()?.status === CONTRACT_APPROVAL_STATUS.SKIPPED"
                        variant="outlined" severity="contrast" (clicked)="toggleApproveDialog()" />
                    <app-button variant="outlined" severity="contrast"
                        [label]="approvalConf()?.status === CONTRACT_APPROVAL_STATUS.SKIPPED ? 'Skipped' : 'Skip Approval'"
                        icon="pi pi-forward" (clicked)="skipApprovalFlow()"
                        [disabled]="!(contract()?.status === CONTRACT_STATUS.READY_FOR_APPROVAL || contract()?.status === CONTRACT_STATUS.PENDING_APPROVAL || contract()?.status === CONTRACT_STATUS.DRAFT) || approvalConf()?.status === CONTRACT_APPROVAL_STATUS.SKIPPED || approvalConf()?.status === CONTRACT_APPROVAL_STATUS.APPROVED" />
                </div>
            </div>
        </ng-template>
        </div>
    `,
    styles: [`
        :host {
            display: block;
            height: 100%;
            width: 100%;
        }
        .approver-file {
            position: relative;
            width: 15rem;
            height: 15rem;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .vector-approver-left {
            position: absolute;
            top: -8rem;
            left: -10rem;
            right: -4rem;
            pointer-events: none;
            z-index: -1;
        }
        .vector-approver-right {
            position: absolute;
            bottom: -8rem;
            right: -10rem;
            left: -4rem;
            pointer-events: none;
            z-index: -1;
        }
        .info {
            color: #6B7280;
        }
        .approver-text {
            margin-top: -3.5rem;
        }
    `]
})
export class ApproversTabComponent implements OnInit, OnDestroy {
    CONTRACT_USER_ROLE = CONTRACT_USER_ROLE;
    CONTRACT_STATUS = CONTRACT_STATUS;
    CONTRACT_APPROVAL_STATUS = CONTRACT_APPROVAL_STATUS;
    flowType = FLOW_TYPE;

    private approvalUpdatedSubscription?: Subscription;

    constructor(
        public dataService: EditContractDataService,
        private socketService: SocketService
    ) { }

    // Use getter methods to access computed signals from the service - these will auto-update!
    get approvalConf() { return this.dataService.approvalConf; }
    get allApprovers() { return this.dataService.allApprovers; }
    get currentRole() { return this.dataService.currentRole; }
    get isOwner() { return this.dataService.isOwner; }
    get isEditor() { return this.dataService.isEditor; }
    get permissions() { return this.dataService.permissions; }
    get contract() { return this.dataService.contract; }

    ngOnInit() {
        this.setupSocketListener();
    }

    ngOnDestroy() {
        if (this.approvalUpdatedSubscription) {
            this.approvalUpdatedSubscription.unsubscribe();
        }
    }

    setupSocketListener() {
        this.approvalUpdatedSubscription = this.socketService
            .on<{ contractId: string; approvalConf: IContractApprovalConf }>(SOCKET_EVENTS.CONTRACT_APPROVAL_UPDATED)
            .subscribe(res => {
                const data = res[0];
                if (data && data.contractId === this.dataService.contractId()) {
                    // Update the approval configuration in the data service
                    const allApprovers = JSON.parse(JSON.stringify(data.approvalConf.approvers || []));
                    this.dataService.updateData({
                        approvalConf: data.approvalConf,
                        allApprovers: allApprovers
                    });
                }
            });
    }

    toggleApproveDialog() {
        const data = this.dataService.getData();
        if (data && data.parent) data.parent.toggleApproveDialog();
    }

    skipApprovalFlow() {
        const data = this.dataService.getData();
        if (data && data.parent) data.parent.skipApprovalFlow();
    }

    resetApprovalFlow() {
        const data = this.dataService.getData();
        if (data && data.parent) data.parent.resetApprovalFlow();
    }

    approvalChange() {
        const data = this.dataService.getData();
        if (data && data.parent) data.parent.approvalChange();
    }
}

